import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./style.css";
import "./styleCard.css";
import ButtonMedita from "../ButtonMedita";
import { CircularProgress, IconButton, makeStyles } from "@material-ui/core";
import IMask from "imask";
import Cards from "./components/Cards";
import Axios from "axios";
import api from "../../core/api";
import { useSnackbar } from "notistack";
import {
  amex,
  amex_single,
  diners,
  diners_single,
  discover,
  discover_single,
  jcb,
  jcb_single,
  maestro,
  maestro_single,
  mastercard,
  mastercard_single,
  unionpay,
  unionpay_single,
  visa,
  visa_single,
} from "./components/svgs";
import CardsRegister from "./components/CardsRegister";
import Modal from "react-modal";
import { Close } from "@material-ui/icons";
import RateChangePlan from "./components/RateChangePlan";
import { useUpdateUser } from "../../hooks/useUpdateUser";
import { useQueryParams } from "../../hooks/useQueryParams";
import { AuthContext } from "../../store/AuthContext";
import SectionMain from "../SectionMain";
import { useLocation } from "react-router-dom";
import useGetPlans from "../../hooks/useGetPlans";
import { checkCouponValidity } from "../../hooks/checkCouponValidity";
import { formatPercent } from "../../utils/formatPercent";
import { format, parseISO } from "date-fns";

const useStyles = makeStyles({
  p: {
    fontWeight: "600",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  pSpan: {
    fontWeight: "600",
    marginBottom: 0,
    textAlign: "left",
  },
  pInfos: {
    fontWeight: "300",
    marginBottom: 0,
    textAlign: "center",
    color: "#030102",
    fontSize: "12px",
    padding: 25,
  },
  stepCard: {
    display: "flex",
    marginTop: "15px",
  },
  modalCancel: {
    width: "500px",
    background: "#fff",
    margin: "200px auto",
    borderRadius: "13px",
    padding: "20px",
    textAlign: "center",
  },
  titleNotice: {
    fontFamily: "Century Gothic",
    fontSize: 13,
    fontWeight: "normal",
    fontStyle: "normal",
    textAlign: "center",
    color: "#183B56",
  },
  bold: { fontWeight: "bold" },
  containerSeven: {
    backgroundColor: "#F3FAF7",
    borderRadius: "150% 150% 0% 0%/40% 40% 0% 0%",
    paddingBottom: "5%",
    position: "absolute",
    left: 0,
  },
  leftSectionSeven: {
    height: "100%",
    maxWidth: "75%",
    margin: "auto",
    marginTop: 50,
  },
  titleSectionSeven: {
    fontFamily: "Century Gothic",
    fontSize: "36px",
    fontWeight: "normal",
    fontStyle: "normal",
    textAlign: "center",
    color: "#3bad76",
    marginTop: 10,
  },
  descriptionSeven: {
    fontFamily: "Century Gothic",
    fontSize: "18px",
    fontWeight: "normal",
    fontStyle: "normal",
    textAlign: "left",
    color: "#5a7084",
  },
  sealView: {
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: "#E1F3EC",
    borderRadius: 40,
    width: "fit-content",
    margin: "auto",
  },
  sealText: {
    fontFamily: "Century Gothic",
    fontSize: "14px",
    fontWeight: "normal",
    fontStyle: "normal",
    textAlign: "center",
    color: "#36B37E",
  },
});

const RegisterCard = ({ setFormStep, nextStep, register, setSubsResponse }) => {
  const [plano, setPlano] = React.useState(localStorage.getItem("plano"));
  const { plans: plansApi } = useGetPlans();

  const classes = useStyles();

  const { enqueueSnackbar } = useSnackbar();

  const snackbar = (message) => {
    enqueueSnackbar(`${message}`, {
      variant: "error",
      anchorOrigin: {
        horizontal: "right",
        vertical: "top",
      },
    });
  };

  const [name, setName] = React.useState("");
  const [loadingSubscription, setLoadingSubscription] = React.useState(false);
  const [cpf, setCpf] = React.useState("");
  const [postalCode, setPostalCode] = React.useState("");
  const [addressNumber, setAddressNumber] = React.useState("");
  const [cellphone, setCellphone] = React.useState("");
  const [selectPlan, setSelectPlan] = useState(null);
  const [modalUpdateIsOpen, setUpdateIsOpen] = React.useState(null);
  const [changePlan, setchangePlan] = React.useState(false);
  const [statusPlan, setStatusPlan] = React.useState("NOTPENDING");
  const idUser = localStorage.getItem("id");

  // CUPOM
  const [couponCode, setCouponCode] = React.useState("");
  const [coupon, setCoupon] = React.useState(null);
  const [couponLoading, setCouponLoading] = React.useState(false);

  const [subscription, setSubs] = useState(null);
  const [expiration, setExpiration] = useState(null);
  const getSubscrition = async () => {
    if (idUser) {
      try {
        await api
          .get(`/subscriptions/users/${idUser}`)
          .then(async ({ data }) => {
            setSubs(data);
          });
      } catch (e) {
        // snackbar("Ops.. algo de errado aconteceu. Tente novamente mais tarde!");
      }
    }
  };
  useEffect(() => {
    getSubscrition();
  }, [getSubscrition]);
  useEffect(() => {
    if (subscription?.subscriptions?.endDate) {
      const today = subscription?.subscriptions?.endDate;
      const date = `${today.slice(8, 10)}/${today.slice(5, 7)}/${today.slice(
        0,
        4,
      )}`;

      setExpiration(date);
    }
  }, [subscription]);

  async function getIp() {
    const { data: ip } = await Axios.get("https://api.ipify.org/?format=json");
    return ip.ip;
  }

  const onHandleSubscription = async () => {
    const name = document.getElementById("name");
    const cardnumber = document.getElementById("cardnumber");
    const expirationdate = document.getElementById("expirationdate");
    const securitycode = document.getElementById("securitycode");

    if (!name.value) {
      snackbar("Nome no cartão obrigatório. Por favor preencha");
      return;
    }
    if (!cardnumber.value) {
      snackbar("Número do cartão obrigatório. Por favor preencha");
      return;
    }
    if (!expirationdate.value) {
      snackbar("Data de vencimento obrigatória. Por favor preencha");
      return;
    }
    if (!securitycode.value) {
      snackbar("CVV obrigatório. Por favor preencha");
      return;
    }
    if (!cpf) {
      snackbar("Cpf obrigatório. Por favor preencha");
      return;
    }

    const ip = await getIp();
    const dateExpirationArray = expirationdate.value.split("/");
    const er = /[^a-z0-9]/gi;
    const form = {
      couponCode: coupon?.valid ? couponCode : null,
      id: localStorage.getItem("id"),
      externalReference: localStorage.getItem("id"),
      cpfCnpj: cpf.replace(er, ""),
      notificationDisabled: false,
      planLabel: selectPlan.id === 2 ? "M" : "Y",
      planId: selectPlan.id === 2 ? plansApi[0].id : plansApi[1].id,
      remoteIp: ip,
      creditCard: {
        holderName: name.value.trim(),
        number: cardnumber.value.replace(er, ""),
        expiryMonth: dateExpirationArray[0],
        expiryYear: dateExpirationArray[1],
        ccv: securitycode.value,
      },
      creditCardHolderInfo: {
        name: localStorage.getItem("name"),
        email: localStorage.getItem("email"),
        cpfCnpj: cpf.replace(er, ""),
        postalCode: postalCode,
        addressNumber: addressNumber,
        addressComplement: null,
        phone: cellphone,
        mobilePhone: cellphone,
      },
    };
    setLoadingSubscription(true);

    try {
      await api.post("/users/assas/subscription", form).then(async (res) => {
        setLoadingSubscription(false);
        if (res.status === 200) {
          setSubsResponse(res.data);
          nextStep();
        }
      });
    } catch (e) {
      setLoadingSubscription(false);
      snackbar(
        e.response.data ||
          "Ops.. Ocorreu um erro na assinatura. Verifique seus dados e tente novamente!",
      );
    }
    setLoadingSubscription(false);
  };

  useEffect(() => {
    const name = document.getElementById("name");
    const cardnumber = document.getElementById("cardnumber");
    const expirationdate = document.getElementById("expirationdate");
    const securitycode = document.getElementById("securitycode");
    const ccicon = document.getElementById("ccicon");
    const ccsingle = document.getElementById("ccsingle");

    //Mask the Credit Card Number Input
    if (cardnumber) {
      var cardnumber_mask = new IMask(cardnumber, {
        mask: [
          {
            mask: "0000 000000 00000",
            regex: "^3[47]\\d{0,13}",
            cardtype: "american express",
          },
          {
            mask: "0000 0000 0000 0000",
            regex: "^(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}",
            cardtype: "discover",
          },
          {
            mask: "0000 000000 0000",
            regex: "^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}",
            cardtype: "diners",
          },
          {
            mask: "0000 0000 0000 0000",
            regex: "^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}",
            cardtype: "mastercard",
          },
          // {
          //     mask: '0000-0000-0000-0000',
          //     regex: '^(5019|4175|4571)\\d{0,12}',
          //     cardtype: 'dankort'
          // },
          // {
          //     mask: '0000-0000-0000-0000',
          //     regex: '^63[7-9]\\d{0,13}',
          //     cardtype: 'instapayment'
          // },
          {
            mask: "0000 000000 00000",
            regex: "^(?:2131|1800)\\d{0,11}",
            cardtype: "jcb15",
          },
          {
            mask: "0000 0000 0000 0000",
            regex: "^(?:35\\d{0,2})\\d{0,12}",
            cardtype: "jcb",
          },
          {
            mask: "0000 0000 0000 0000",
            regex: "^(?:5[0678]\\d{0,2}|6304|67\\d{0,2})\\d{0,12}",
            cardtype: "maestro",
          },
          // {
          //     mask: '0000-0000-0000-0000',
          //     regex: '^220[0-4]\\d{0,12}',
          //     cardtype: 'mir'
          // },
          {
            mask: "0000 0000 0000 0000",
            regex: "^4\\d{0,15}",
            cardtype: "visa",
          },
          {
            mask: "0000 0000 0000 0000",
            regex: "^62\\d{0,14}",
            cardtype: "unionpay",
          },
          {
            mask: "0000 0000 0000 0000",
            cardtype: "Unknown",
          },
        ],
        dispatch: function (appended, dynamicMasked) {
          var number = (dynamicMasked.value + appended).replace(/\D/g, "");

          for (var i = 0; i < dynamicMasked.compiledMasks.length; i++) {
            let re = new RegExp(dynamicMasked.compiledMasks[i].regex);
            if (number.match(re) != null) {
              return dynamicMasked.compiledMasks[i];
            }
          }
        },
      });

      //Mask the Expiration Date
      var expirationdate_mask = new IMask(expirationdate, {
        mask: "00{/}00",
      });

      //Mask the security code
      var securitycode_mask = new IMask(securitycode, {
        mask: "0000",
      });

      IMask(document.getElementById("cpfcnpj"), {
        mask: [
          {
            mask: "000.000.000-00",
            maxLength: 11,
          },
          {
            mask: "00.000.000/0000-00",
          },
        ],
      });

      IMask(document.getElementById("cell"), {
        mask: [
          {
            mask: "(00) 0000-0000",
            maxLength: 11,
          },
          {
            mask: "(00) 0 0000-0000",
          },
        ],
      });

      IMask(document.getElementById("cep"), {
        mask: [
          {
            mask: "00.000-000",
          },
        ],
      });

      //define the color swap function
      const swapColor = function (basecolor) {
        document.querySelectorAll(".lightcolor").forEach(function (input) {
          input.setAttribute("class", "");
          input.setAttribute("class", "lightcolor " + basecolor);
        });
        document.querySelectorAll(".darkcolor").forEach(function (input) {
          input.setAttribute("class", "");
          input.setAttribute("class", "darkcolor " + basecolor + "dark");
        });
      };

      //pop in the appropriate card icon when detected
      cardnumber_mask.on("accept", function () {
        switch (cardnumber_mask.masked.currentMask.cardtype) {
          case "american express":
            ccicon.innerHTML = amex;
            ccsingle.innerHTML = amex_single;
            swapColor("green");
            break;
          case "visa":
            ccicon.innerHTML = visa;
            ccsingle.innerHTML = visa_single;
            swapColor("lime");
            break;
          case "diners":
            ccicon.innerHTML = diners;
            ccsingle.innerHTML = diners_single;
            swapColor("orange");
            break;
          case "discover":
            ccicon.innerHTML = discover;
            ccsingle.innerHTML = discover_single;
            swapColor("purple");
            break;
          case "jcb" || "jcb15":
            ccicon.innerHTML = jcb;
            ccsingle.innerHTML = jcb_single;
            swapColor("red");
            break;
          case "maestro":
            ccicon.innerHTML = maestro;
            ccsingle.innerHTML = maestro_single;
            swapColor("yellow");
            break;
          case "mastercard":
            ccicon.innerHTML = mastercard;
            ccsingle.innerHTML = mastercard_single;
            swapColor("lightblue");

            break;
          case "unionpay":
            ccicon.innerHTML = unionpay;
            ccsingle.innerHTML = unionpay_single;
            swapColor("cyan");
            break;
          default:
            ccicon.innerHTML = "";
            ccsingle.innerHTML = "";
            swapColor("grey");
            break;
        }
      });

      // CREDIT CARD IMAGE JS
      if (document.querySelector(".preload"))
        document.querySelector(".preload").classList.remove("preload");
      document
        .querySelector(".creditcard")
        .addEventListener("click", function () {
          if (this.classList.contains("flipped")) {
            this.classList.remove("flipped");
          } else {
            this.classList.add("flipped");
          }
        });

      //On Input Change Events
      name.addEventListener("input", function () {
        if (name.value.length == 0) {
          document.getElementById("svgname").innerHTML = "John Doe";
          document.getElementById("svgnameback").innerHTML = "John Doe";
        } else {
          document.getElementById("svgname").innerHTML = this.value;
          document.getElementById("svgnameback").innerHTML = this.value;
        }
      });

      cardnumber_mask.on("accept", function () {
        if (cardnumber_mask.value.length == 0) {
          document.getElementById("svgnumber").innerHTML =
            "0123 4567 8910 1112";
        } else {
          document.getElementById("svgnumber").innerHTML =
            cardnumber_mask.value;
        }
      });

      expirationdate_mask.on("accept", function () {
        if (expirationdate_mask.value.length == 0) {
          document.getElementById("svgexpire").innerHTML = "01/23";
        } else {
          document.getElementById("svgexpire").innerHTML =
            expirationdate_mask.value;
        }
      });

      securitycode_mask.on("accept", function () {
        if (securitycode_mask.value.length == 0) {
          document.getElementById("svgsecurity").innerHTML = "985";
        } else {
          document.getElementById("svgsecurity").innerHTML =
            securitycode_mask.value;
        }
      });

      //On Focus Events
      name.addEventListener("focus", function () {
        document.querySelector(".creditcard").classList.remove("flipped");
      });

      cardnumber.addEventListener("focus", function () {
        document.querySelector(".creditcard").classList.remove("flipped");
      });

      expirationdate.addEventListener("focus", function () {
        document.querySelector(".creditcard").classList.remove("flipped");
      });

      securitycode.addEventListener("focus", function () {
        document.querySelector(".creditcard").classList.add("flipped");
      });
    }
  }, [selectPlan]);

  const UpdateUser = async () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const res = await useUpdateUser();
    setPlano(res?.premium);
    if (res?.subscription_assas_id) {
      try {
        const result = JSON.parse(res?.subscription_assas_id);
        const planBody = result.filter((r) => r.status === "PENDING");
        if (
          planBody.length > 0 &&
          planBody[planBody.length - 1].status === "PENDING"
        ) {
          setStatusPlan("PENDING");
        }
      } catch (error) {}
    }
  };
  useEffect(() => {
    UpdateUser();
  }, []);

  const { setToken, setData } = useContext(AuthContext);

  const params = useQueryParams();
  const GetUserByToken = async () => {
    if (params) {
      try {
        await api.get("/auth/redirect").then(async (res) => {
          localStorage.setItem("id", res.data.user.id);
          localStorage.setItem("name", res.data.user.name);
          localStorage.setItem("nickName", res.data.user.nickName);
          localStorage.setItem("email", res.data.user.email);
          localStorage.setItem("avatarUrl", res.data.user.avatarUrl);
          localStorage.setItem("plano", res.data.user.premium);

          setToken(res.data.token);
          setData(res.data.user);
        });
      } catch (error) {}
    }
  };

  const plans = useMemo(() => {
    let base = [
      {
        id: 1,
        price: plansApi[1]?.value || "-",
        name: "Medita.Sempre",
        frequency: "anual",
        plan_name: "Medita.Sempre",
        two_name: "Sempre",
        title: "PREMIUM",
        description:
          "Assine o plano anual e garanta 12 meses de transformação completa com benefícios exclusivos para uma vida de mais equilíbrio, paz e bem-estar.",
        introduction: "",
        items: [
          {
            title: "Acesso aos conteúdos premium",
            description:
              "Imersão total no bem-estar, com práticas transformadoras.",
          },
          {
            title: "Sem anúncios",
            description: "Sua jornada de equilíbrio sem interrupções.",
          },
          {
            title: "Salve seus conteúdos favoritos",
            description:
              "Tenha sua própria biblioteca de bem-estar sempre ao seu alcance.",
          },
          {
            title: "Crie playlists ilimitadas",
            description:
              "Medite, relaxe e organize suas práticas favoritas para cada momento do seu dia.",
          },
          {
            title: "Benefícios exclusivos",
            description:
              "Descontos em cursos, eventos e parcerias que vão além do app, ajudando a transformar sua vida por completo.",
          },
        ],
        notice: (
          <div>
            <span className={classes.titleNotice}>
              Invista no seu bem-estar a longo prazo e
              <span className={classes.bold}>
                {" "}
                aproveite os benefícios exclusivos{" "}
              </span>
              criados para deixar sua jornada cada vez
              <span className={classes.bold}> mais leve e equilibrada</span>.
            </span>
          </div>
        ),
        outcome: "",
        activePlan: plano === "Y",
        showDiscountBanner: true,
        percentage: "60",
      },

      {
        id: 2,
        price: plansApi[0]?.value || "-",
        name: "Medita.Bem+",
        frequency: "mensal",
        plan_name: "Medita.Bem+",
        two_name: "Bem+",
        title: "PREMIUM",
        description:
          "Transforme sua rotina com acesso completo a meditações guiadas, exercícios, yoga, músicas, mantras e vídeos que trazem mais equilíbrio e bem-estar.",
        introduction: "",
        items: [
          {
            title: "Acesso aos conteúdos premium",
            description:
              "Tenha o universo completo de bem-estar ao seu alcance.",
          },
          {
            title: "Sem anúncios",
            description: "Foco total no que realmente importa: você.",
          },
          {
            title: "Salve seus conteúdos favoritos",
            description:
              "Mantenha sua coleção de meditações e práticas sempre à mão.",
          },
          {
            title: "Crie playlists ilimitadas",
            description:
              "Personalize sua prática com a sequência perfeita para relaxar, meditar ou energizar seu dia.",
          },
        ],
        notice: (
          <div>
            <span className={classes.titleNotice}>
              Comece sua
              <span className={classes.bold}> jornada</span> de
              <span className={classes.bold}> bem-estar</span> e encontre o seu
              refúgio de
              <span className={classes.bold}>
                {" "}
                paz e equilíbrio todos os dias
              </span>
              .
            </span>
          </div>
        ),
        outcome: "",
        activePlan: plano === "M",
      },
      {
        id: 3,
        name: "FREE",
        plan_name: "Medita.Bem",
        two_name: "Free",
        title: "FREE",
        description:
          "Experimente alguns conteúdos gratuitos de meditação guiada, músicas, mantras e áudios e dê o primeiro passo para dias mais leves e equilibrados.",
        introduction: "",
        items: [
          {
            title: "Acesso aos conteúdos gratuitos",
            description:
              "Explore, salve e crie playlists sem anúncios ou interrupções.",
          },
        ],
        notice: (
          <div>
            <span className={classes.titleNotice}>
              Primeira vez por aqui? Experimente
              <span className={classes.bold}>
                {" "}
                todos os conteúdos do MeditaBem por 14 dias
              </span>{" "}
              .
            </span>
          </div>
        ),
        outcome: "",
        activePlan: plano === "F" || plano === "N",
      },
    ];
    if (params?.plano) {
      if (params?.plano === "mensal") base = base.filter((b) => b.id === 2);
      if (params?.plano === "anual") base = base.filter((b) => b.id === 1);
    }
    return base;
  }, [plansApi, plano, classes, params]);

  useEffect(() => {
    if (params?.id) {
      setSelectPlan(plans[params?.id - 1]);
    }

    if (params?.token) {
      localStorage.setItem("token", params?.token);
      GetUserByToken(params?.token);
    }
  }, [GetUserByToken, params, plans]);

  const myRef = useRef(null);
  useEffect(() => {
    if (myRef?.current) {
      myRef.current.scrollIntoView({ block: "end", behavior: "smooth" });
    }
  }, [selectPlan]);

  useEffect(() => {
    if (register && plano === "S") nextStep();
  }, [nextStep, plano, register]);

  return (
    <div style={{ width: "100%" }}>
      <div ref={myRef}></div>

      {!selectPlan ? (
        <SectionMain noPadding className={classes.containerSeven}>
          <div className={classes.leftSectionSeven}>
            <div className={classes.sealView}>
              <span className={classes.sealText}>Planos</span>
            </div>
            <div className={classes.titleSectionSeven}>
              Escolha seu plano
              <br />
              <span className={classes.descriptionSeven}>
                Assine o seu app MeditaBem diretamente aqui no site e conte com
                os valores exclusivos abaixo:
              </span>
            </div>
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {register ? (
              <CardsRegister
                setSelectPlan={setSelectPlan}
                setFormStep={setFormStep}
                register={register}
                plans={plans}
                statusPlan={statusPlan}
                subscription={subscription}
              />
            ) : (
              <Cards
                setSelectPlan={setSelectPlan}
                setFormStep={setFormStep}
                register={register}
                plans={plans}
                statusPlan={statusPlan}
                subscription={subscription}
              />
            )}
          </div>
        </SectionMain>
      ) : (
        <div
          className="form"
          style={{
            width: "700px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "75%",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
              padding: 15,
              borderRadius: 15,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: 20,
            }}
          >
            <div className="container preload">
              <div className="creditcard">
                <div className="front">
                  <div id="ccsingle"></div>
                  <svg
                    version="1.1"
                    id="cardfront"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 750 471"
                  >
                    <g id="Front">
                      <rect
                        x="0.5"
                        width="100%"
                        height="100%"
                        rx="16"
                        fill="url(#paint0_linear_93_261)"
                      />
                      <linearGradient
                        id="paint0_linear_93_261"
                        x1="0.5"
                        y1="0"
                        x2="308.989"
                        y2="209.429"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#FED4B4" />
                        <stop offset="1" stop-color="#3BB9A1" />
                      </linearGradient>
                      <text
                        transform="matrix(1 0 0 1 60.106 295.0121)"
                        id="svgnumber"
                        className="st2 st3 st4"
                      >
                        0123 4567 8910 1112
                      </text>

                      <text
                        transform="matrix(1 0 0 1 54.1064 428.1723)"
                        id="svgname"
                        className="stUp"
                        textLength={name.length > 20 ? "50%" : ""}
                      >
                        Harley Keener
                      </text>

                      <text
                        transform="matrix(1 0 0 1 54.1074 389.8793)"
                        className="st7 st5 st8"
                      >
                        Nome
                      </text>
                      <text
                        transform="matrix(1 0 0 1 479.7754 388.8793)"
                        className="st7 st5 st8"
                      >
                        Data de validade
                      </text>

                      <g>
                        <text
                          transform="matrix(1 0 0 1 479.7754 433.8095)"
                          id="svgexpire"
                          className="st2 st5 st9"
                        >
                          01/23
                        </text>
                      </g>
                      <g id="cchip">
                        <g>
                          <path
                            className="st2"
                            d="M168.1,143.6H82.9c-10.2,0-18.5-8.3-18.5-18.5V74.9c0-10.2,8.3-18.5,18.5-18.5h85.3
                        c10.2,0,18.5,8.3,18.5,18.5v50.2C186.6,135.3,178.3,143.6,168.1,143.6z"
                          />
                        </g>
                        <g>
                          <g>
                            <rect
                              x="82"
                              y="70"
                              className="st12"
                              width="1.5"
                              height="60"
                            />
                          </g>
                          <g>
                            <rect
                              x="167.4"
                              y="70"
                              className="st12"
                              width="1.5"
                              height="60"
                            />
                          </g>
                          <g>
                            <path
                              className="st12"
                              d="M125.5,130.8c-10.2,0-18.5-8.3-18.5-18.5c0-4.6,1.7-8.9,4.7-12.3c-3-3.4-4.7-7.7-4.7-12.3
                            c0-10.2,8.3-18.5,18.5-18.5s18.5,8.3,18.5,18.5c0,4.6-1.7,8.9-4.7,12.3c3,3.4,4.7,7.7,4.7,12.3
                            C143.9,122.5,135.7,130.8,125.5,130.8z M125.5,70.8c-9.3,0-16.9,7.6-16.9,16.9c0,4.4,1.7,8.6,4.8,11.8l0.5,0.5l-0.5,0.5
                            c-3.1,3.2-4.8,7.4-4.8,11.8c0,9.3,7.6,16.9,16.9,16.9s16.9-7.6,16.9-16.9c0-4.4-1.7-8.6-4.8-11.8l-0.5-0.5l0.5-0.5
                            c3.1-3.2,4.8-7.4,4.8-11.8C142.4,78.4,134.8,70.8,125.5,70.8z"
                            />
                          </g>
                          <g>
                            <rect
                              x="82.8"
                              y="82.1"
                              className="st12"
                              width="25.8"
                              height="1.5"
                            />
                          </g>
                          <g>
                            <rect
                              x="82.8"
                              y="117.9"
                              className="st12"
                              width="26.1"
                              height="1.5"
                            />
                          </g>
                          <g>
                            <rect
                              x="142.4"
                              y="82.1"
                              className="st12"
                              width="25.8"
                              height="1.5"
                            />
                          </g>
                          <g>
                            <rect
                              x="142"
                              y="117.9"
                              className="st12"
                              width="26.2"
                              height="1.5"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Back"></g>
                  </svg>
                </div>
                <div className="back">
                  <svg
                    version="1.1"
                    id="cardback"
                    xmlns="http://www.w3.org/2000/svg"
                    xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 750 471"
                    style={{ enableBackground: "new 0 0 750 471" }}
                    space="preserve"
                    overflow="auto"
                  >
                    <g id="Front">
                      <line
                        className="st0"
                        x1="35.3"
                        y1="10.4"
                        x2="36.7"
                        y2="11"
                      />
                    </g>
                    <g id="Back">
                      <g id="Page-1_2_">
                        <g id="amex_2_">
                          <path
                            id="Rectangle-1_2_"
                            className="darkcolor greydark"
                            d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                        C0,17.9,17.9,0,40,0z"
                          />
                        </g>
                      </g>
                      <rect y="61.6" className="st2" width="750" height="78" />
                      <g>
                        <path
                          className="st3"
                          d="M701.1,249.1H48.9c-3.3,0-6-2.7-6-6v-52.5c0-3.3,2.7-6,6-6h652.1c3.3,0,6,2.7,6,6v52.5
                    C707.1,246.4,704.4,249.1,701.1,249.1z"
                        />
                        <rect
                          x="42.9"
                          y="198.6"
                          className="st4"
                          width="664.1"
                          height="10.5"
                        />
                        <rect
                          x="42.9"
                          y="224.5"
                          className="st4"
                          width="664.1"
                          height="10.5"
                        />
                        <path
                          className="st5"
                          d="M701.1,184.6H618h-8h-10v64.5h10h8h83.1c3.3,0,6-2.7,6-6v-52.5C707.1,187.3,704.4,184.6,701.1,184.6z"
                        />
                      </g>
                      <text
                        transform="matrix(1 0 0 1 621.999 227.2734)"
                        id="svgsecurity"
                        className="st6 st7"
                      >
                        985
                      </text>
                      <g className="st8">
                        <text
                          transform="matrix(1 0 0 1 518.083 280.0879)"
                          className="st9 st6 st10"
                        >
                          security code
                        </text>
                      </g>
                      <rect
                        x="58.1"
                        y="378.6"
                        className="st11"
                        width="375.5"
                        height="13.5"
                      />
                      <rect
                        x="58.1"
                        y="405.6"
                        className="st11"
                        width="421.7"
                        height="13.5"
                      />
                      <text
                        transform="matrix(1 0 0 1 59.5073 228.6099)"
                        id="svgnameback"
                        className="st12 st15"
                      >
                        Harley Keener
                      </text>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div className={classes.p}>
              <p className={classes.pSpan}>
                Informe os dados do seu cartão de crédito
              </p>
            </div>
            <div className="form-container">
              <div className="field-container">
                <label for="name">
                  Nome no cartão<label style={{ color: "red" }}>*</label>
                </label>
                <input
                  id="name"
                  type="text"
                  onChange={({ target }) => {
                    setName(target.value);
                  }}
                />
              </div>
              <div className="field-container">
                <label for="cardnumber">
                  Número do Cartão<label style={{ color: "red" }}>*</label>
                </label>

                <input
                  id="cardnumber"
                  type="text"
                  pattern="[0-9]*"
                  inputmode="numeric"
                />
                <svg
                  id="ccicon"
                  className="ccicon"
                  width="750"
                  height="471"
                  viewBox="0 0 750 471"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                ></svg>
              </div>
              <div className="field-container">
                <label for="expirationdate">
                  Data de Validade<label style={{ color: "red" }}>*</label>
                </label>
                <input
                  id="expirationdate"
                  type="text"
                  pattern="[0-9]*"
                  inputmode="numeric"
                />
              </div>
              <div className="field-container">
                <label for="securitycode">
                  CVV<label style={{ color: "red" }}>*</label>
                </label>
                <input
                  id="securitycode"
                  type="text"
                  pattern="[0-9]*"
                  inputmode="numeric"
                />
              </div>
              <div className="field-container">
                <label for="cpf">
                  CPF/CNPJ<label style={{ color: "red" }}>*</label>
                </label>
                <input
                  id="cpfcnpj"
                  maxlength="20"
                  type="text"
                  onChange={(text) => setCpf(text.target.value)}
                />
              </div>
              <div className="field-container">
                <label for="cell">
                  Celular<label style={{ color: "red" }}>*</label>
                </label>
                <input
                  id="cell"
                  maxlength="20"
                  type="text"
                  onChange={(text) => setCellphone(text.target.value)}
                />
              </div>
              <div className="field-container">
                <label for="cep">CEP</label>
                <input
                  id="cep"
                  type="text"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  onChange={(text) => setPostalCode(text.target.value)}
                />
              </div>
              <div className="field-container">
                <label for="securitycode">Nº do endereço</label>
                <input
                  id="securitycode"
                  type="text"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  onChange={(text) => setAddressNumber(text.target.value)}
                />
              </div>
            </div>{" "}
            <div style={{ marginTop: 10, width: "100%", marginBottom: 15 }}>
              <label>Plano & Preço selecionado</label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 10,
                  backgroundColor: "#f4f4f4",
                  height: 50,
                }}
              >
                <span style={{ width: "50%" }}>{selectPlan.name}</span>
                <span style={{ width: "50%" }}>
                  R$ {selectPlan.price}/{selectPlan.frequency}
                </span>
                {plano !== "Y" && plano !== "M" && (
                  <ButtonMedita
                    backgroundColor="#316570"
                    width="33%"
                    onClick={() => {
                      setchangePlan(true);
                      setCoupon(null);
                    }}
                  >
                    Mudar
                  </ButtonMedita>
                )}
              </div>
            </div>
            <div style={{ marginTop: 10, width: "100%", marginBottom: 15 }}>
              <label>Cupom de desconto</label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 10,
                  backgroundColor: "#f4f4f4",
                  height: 50,
                }}
              >
                <input
                  id="coupon"
                  type="text"
                  style={{ width: "50%" }}
                  onChange={(text) => {
                    setCoupon(null);
                    setCouponCode(text.target.value);
                  }}
                />
                <ButtonMedita
                  variant="outlined"
                  width="40%"
                  loading={couponLoading}
                  disabled={couponLoading}
                  onClick={async () => {
                    setCouponLoading(true);
                    try {
                      const couponV = await checkCouponValidity({
                        couponCode,
                        userId: idUser,
                        planId:
                          selectPlan.id === 2 ? plansApi[0].id : plansApi[1].id,
                      });

                      console.log(couponV.data);
                      setCoupon(couponV.data);
                    } finally {
                      setCouponLoading(false);
                    }
                  }}
                >
                  Aplicar cupom
                </ButtonMedita>
              </div>
              {coupon &&
                (!coupon?.valid ? (
                  <p className={{ color: "red" }}>CUPOM INVÁLIDO</p>
                ) : (
                  <div>
                    <div className="coupon-info">
                      <p>
                        ✅ <strong>CUPOM APLICADO</strong>
                      </p>
                      <div style={{ display: "flex" }}>
                        <p>
                          <strong>Valor original:</strong> R$ {selectPlan.price}
                        </p>
                        <p>
                          <strong>Desconto:</strong>
                          {coupon.discountType === "fixed"
                            ? ` R$ ${coupon.value?.replace(".", ",")}`
                            : formatPercent(coupon.value)}
                        </p>
                        <p>
                          <strong>Valor final:</strong> R${" "}
                          {coupon.discountedPlanValue
                            .toFixed(2)
                            ?.replace(".", ",")}
                        </p>
                      </div>
                    </div>
                    <p>
                      Parabéns, cupom aplicado, ao assinar você pagará o valor
                      de
                      <br />
                      <b>
                        R${" "}
                        {coupon.discountedPlanValue
                          .toFixed(2)
                          ?.replace(".", ",")}
                      </b>{" "}
                      {coupon.validationType === "byDate" ? (
                        <>
                          {" "}
                          até a data de expiração
                          <b>
                            {coupon.validUntil
                              ? `: ${format(
                                  new Date(
                                    coupon.validUntil.split("T")[0] +
                                      "T12:00:00",
                                  ),
                                  "dd/MM/yyyy",
                                )}`
                              : "."}
                          </b>
                        </>
                      ) : (
                        <>
                          {" "}
                          por <b>{coupon.discountedPayments}</b> parcela(s)
                        </>
                      )}
                      . <br />
                      Atenção, a partir da data de expiração, o seu plano será
                      reajustado para seu valor regular de{" "}
                      <b>R$ {selectPlan.price}</b>. Aproveite!
                    </p>
                  </div>
                ))}
            </div>
            <div className={classes.p}>
              <p className={classes.pInfos}>
                Ao clicar no botão “Confirmar Pagamento” abaixo, você concorda
                com nosso Termo de Uso e Privacidade, confirma ter mais de 18
                anos e aceita que a MeditaBem renove automaticamente sua
                assinatura e cobre o preço da assinatura acima da sua forma de
                pagamento até você cancelar. Você pode cancelar quando quiser
                para evitar cobranças futuras. Para cancelar, acesse seu perfil
                no site e clique em “Cancelar assinatura”.
              </p>
            </div>{" "}
            <ButtonMedita
              disabled={loadingSubscription}
              loading={loadingSubscription}
              type="button"
              onClick={() => {
                if (plansApi.length < 2 && selectPlan.id !== 1)
                  return snackbar(
                    "Ocorreu um erro. Tente novamente mais tarde",
                  );
                if (
                  (selectPlan.id === 2 && plano === "Y") ||
                  (selectPlan.id === 3 && plano === "M")
                ) {
                  return setUpdateIsOpen(selectPlan);
                }
                onHandleSubscription();
              }}
              size="large"
              style={{ marginTop: "10px" }}
            >
              Confirmar Pagamento
            </ButtonMedita>
            <ButtonMedita
              // disabled={formikProps.isSubmitting}
              variant="outlined"
              type="button"
              onClick={() => {
                setSelectPlan(null);
              }}
              size="large"
              style={{ marginTop: "10px" }}
            >
              Cancelar
            </ButtonMedita>
          </div>
        </div>
      )}
      <Modal
        isOpen={modalUpdateIsOpen !== null}
        onRequestClose={() => setUpdateIsOpen(null)}
        contentLabel="Comprar Plano"
        className={classes.modalCancel}
      >
        <div style={{ display: "flex" }}>
          <IconButton size="large" onClick={() => setUpdateIsOpen(null)}>
            <Close />
          </IconButton>
        </div>
        <h3 className={classes.modalDeleteTitle}>
          Seu plano atual é o {plano === "Y" ? "Anual" : "Mensal"} e será
          mantido até o vencimento {expiration || null}. Mas não se preocupe. A
          troca e cobrança do seu novo plano será feita somente após esta data.{" "}
          {`\n`}
          <b>Importante:</b> durante esse período nenhuma outra ação pode ser
          realizada, para que a transição seja concluída totalmente.
        </h3>

        <ButtonMedita
          type="button"
          onClick={() => {
            if (plansApi.length < 2 && selectPlan.id !== 1)
              return snackbar("Ocorreu um erro. Tente novamente mais tarde");
            setUpdateIsOpen(null);
            onHandleSubscription();
          }}
        >
          Continuar
        </ButtonMedita>
      </Modal>
      <Modal
        isOpen={changePlan}
        onRequestClose={() => setchangePlan(null)}
        contentLabel="Alterar plano"
        className={classes.modalCancel}
      >
        <div style={{ display: "flex" }}>
          <IconButton size="large" onClick={() => setchangePlan(null)}>
            <Close />
          </IconButton>
        </div>
        <RateChangePlan
          plans={plans}
          setSelectPlan={setSelectPlan}
          setchangePlan={setchangePlan}
          selectPlan={selectPlan}
        />
      </Modal>
    </div>
  );
};

export default RegisterCard;
